/**
 * The registration wall: the gate that stops an anonymous person mid-action and sends them to
 * sign up.
 *
 * It lives with authentication because that is what it does — every caller is asking "may
 * this person proceed, and if not, sign them up first". It was named for the placeholder it
 * also produces (`useUnknownProfile`), which is the smaller half: that placeholder is Profile
 * presentation riding along, and splitting it out is a separate decision. See EPIC-005.
 */
import { AppStatus, Session, SessionState } from '@/redux'
import { QueryKeys } from '@/services/api/session/queryKeys'
import { TypeGuards } from '@codeleap/common'
import { AnyRecord } from '@codeleap/types'
import { navigate } from 'gatsby'

export const openRegistrationWall = (isUnknown = true, onAuth?: AnyRecord) => {
  return () => {
    if (isUnknown) {
      return AppStatus.setModal('authWall')
    }

    if (TypeGuards.isFunction(onAuth)) {
      onAuth?.()
    }
  }
}

export const maybeOpenRegistrationWall = (
  open = true,
  isOpenModal = false,
  variant?: SessionState['registrationWallVariant']
) => {
  const profile = QueryKeys.me.getData()
  const isUnknown = TypeGuards.isNil(profile)

  if (isUnknown && isOpenModal) {
    Session.setRegistrationWallVariant(variant ?? null)
    AppStatus.setModal('authWall')
  } else if (isUnknown && open) {
    navigate('/auth/signup/')
  }

  return !isUnknown
}
